import MagneticButton from './MagneticButton';

const tiers = [
  {
    name: 'Diagnostic',
    statement:
      'Fixed-scope, fixed-fee Technical Blueprint. The mandatory front door to every project — architecture, credentials, test cases, edge cases, deployment plan.',
    deliverables: [
      'Full technical blueprint',
      'Architecture & data flow',
      'Risk & test case register',
    ],
  },
  {
    name: 'Build',
    statement:
      'Blueprint-led delivery. Engineering-grade implementation, tested, deployed, monitored. The Blueprint is the contract; we ship against it.',
    deliverables: [
      'Production implementation',
      'CI-enforced test cases',
      'Deployment & runbook',
    ],
  },
  {
    name: 'Embedded',
    statement:
      'Ongoing partnership. Continuous improvement, new workflows, in-team availability. For firms running Samia-built systems in production.',
    deliverables: [
      'Quarterly improvement plan',
      'New workflow delivery',
      'Monitoring & response',
    ],
  },
];

export default function EngagementTiers() {
  return (
    <section className="grain relative bg-black py-32">
      <div className="container-x">
        <div className="mb-20 max-w-3xl">
          <p className="label mb-6 inline-flex items-center gap-3">
            <span className="h-px w-10 bg-gold" />
            Engagement Tiers
          </p>
          <h2 className="font-display text-section font-light text-white text-balance">
            Three ways to work with us. One way to begin.
          </h2>
          <p className="mt-6 max-w-xl font-sans text-body text-white/85">
            Every engagement starts with a Diagnostic. Build and Embedded tiers
            extend from the Blueprint that diagnostic produces.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {tiers.map((t, i) => (
            <article
              key={t.name}
              className="grain relative flex flex-col justify-between overflow-hidden rounded-4xl border border-white/10 bg-charcoal p-8"
            >
              <div>
                <p className="font-mono text-xs uppercase tracking-label text-gold">
                  Tier 0{i + 1}
                </p>
                <h3 className="mt-4 font-display text-3xl font-light text-white">
                  {t.name}
                </h3>
                <p className="mt-4 font-sans text-body text-white/85">
                  {t.statement}
                </p>

                <ul className="mt-8 flex flex-col gap-3 border-t border-white/10 pt-6">
                  {t.deliverables.map((d) => (
                    <li
                      key={d}
                      className="flex items-start gap-3 font-sans text-[0.78rem] uppercase tracking-label text-white/85"
                    >
                      <span className="mt-1 inline-block h-px w-4 bg-gold" />
                      {d}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-10">
                <MagneticButton to="/book">Book a Diagnostic</MagneticButton>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
